export interface CustomSearchDefinition {
  id?: string
  name?: LangStringYomi
  type?: CSType
  description?: LangString
  help?: LangDelta
  databaseIds?: string[]
  searchFields?: CustomSearchField[]
  constraints?: CustomSearchConstraint[]
  columns?: CustomSearchColumn[]
  keywordFields?: string[]
  keywordPlaceholder?: LangString
  sampleQuery?: SearchQuery[]
  sorts?: string[]
  image?: ImageSelection
  permission?: Permission
  edit?: Edit
}

export interface CustomSearchField {
  key?: string
  name?: LangString
  description?: LangString
  type?: SearchFieldType
  fields?: string[]
  placeHolder?: LangString
  samples?: LangString[]
  codeKey?: string
  hidden?: boolean
  hasFacet?: boolean
  hasSideBarFacet?: boolean
  sideBarFacetShowCount?: number
  facetIncludePattern?: string
  facetSize?: number
}

export interface CustomSearchConstraint {
  c?: SearchLogicType
  q?: SearchQuery
  note?: LangString
}

export interface CustomSearchColumn {
  header?: LangString
  fields?: string[]
  type?: SearchColumnType
  codeKey?: string
}

export type CSType =
  'NORMAL' |
  'NOTE' |
  'DB'
export const C_S_TYPE_DEF: EnumDef = Object.freeze({
  id: 'jps-c_s_type',
  c: {
    NORMAL: {
      l: {
        ja: '通常',
        en: 'Normal'
      },
      d: {}
    },
    NOTE: {
      l: {
        ja: 'ギャラリー用',
        en: 'For Gallery'
      },
      d: {}
    },
    DB: {
      l: {
        ja: 'データベース用',
        en: 'Database'
      },
      d: {}
    }
  }
})
export type SearchFieldType =
  'keyword' |
  'code' |
  'coordinates' |
  'time_range' |
  'number_range' |
  'exist' |
  'organization' |
  'provider' |
  'location' |
  'prefectures' |
  'temporal' |
  'temporal_group' |
  'database' |
  'contents' |
  'rdf_type' |
  'last_update' |
  'tag' |
  'image' |
  'permission' |
  'owner_org'
export const SEARCH_FIELD_TYPE_DEF: EnumDef = Object.freeze({
  id: 'jps-search_field_type',
  c: {
    keyword: {
      l: {
        ja: 'キーワード',
        en: 'Keywords'
      },
      d: {}
    },
    code: {
      l: {
        ja: 'コード',
        en: 'Code'
      },
      d: {}
    },
    coordinates: {
      l: {
        ja: '座標',
        en: 'Coordinates'
      },
      d: {}
    },
    time_range: {
      l: {
        ja: '時間範囲',
        en: 'Time Range'
      },
      d: {}
    },
    number_range: {
      l: {
        ja: '数値',
        en: 'Number'
      },
      d: {}
    },
    exist: {
      l: {
        ja: '値の有無',
        en: 'Exists'
      },
      d: {}
    },
    organization: {
      l: {
        ja: 'つなぎ役',
        en: 'Organization'
      },
      d: {}
    },
    provider: {
      l: {
        ja: '所蔵機関',
        en: 'Provider'
      },
      d: {}
    },
    location: {
      l: {
        ja: '場所',
        en: 'Location'
      },
      d: {}
    },
    prefectures: {
      l: {
        ja: '場所',
        en: 'Location'
      },
      d: {}
    },
    temporal: {
      l: {
        ja: '時間/時代',
        en: 'Time'
      },
      d: {}
    },
    temporal_group: {
      l: {
        ja: '時間',
        en: 'Time'
      },
      d: {}
    },
    database: {
      l: {
        ja: 'データベース',
        en: 'DB'
      },
      d: {}
    },
    contents: {
      l: {
        ja: 'コンテンツ',
        en: 'Contents'
      },
      d: {}
    },
    rdf_type: {
      l: {
        ja: 'RDF種別',
        en: 'RDF Types'
      },
      d: {}
    },
    last_update: {
      l: {
        ja: '最終更新日',
        en: 'Last Updated'
      },
      d: {}
    },
    tag: {
      l: {
        ja: 'タグ',
        en: 'Tags'
      },
      d: {}
    },
    image: {
      l: {
        ja: '画像検索',
        en: 'Image Search'
      },
      d: {}
    },
    permission: {
      l: {
        ja: '権限',
        en: 'Permission'
      },
      d: {}
    },
    owner_org: {
      l: {
        ja: '権限',
        en: 'OwnerOrg'
      },
      d: {}
    }
  }
})
export type SearchLogicType =
  'AND' |
  'OR' |
  'NOT'
export const SEARCH_LOGIC_TYPE_DEF: EnumDef = Object.freeze({
  id: 'jps-search_logic_type',
  c: {
    AND: {
      l: {
        ja: 'And'
      },
      d: {}
    },
    OR: {
      l: {
        ja: 'Or'
      },
      d: {}
    },
    NOT: {
      l: {
        ja: 'Not'
      },
      d: {}
    }
  }
})
export type SearchColumnType =
  'field' |
  'code' |
  'title' |
  'database' |
  'database_site' |
  'provider' |
  'organization'
export const SEARCH_COLUMN_TYPE_DEF: EnumDef = Object.freeze({
  id: 'jps-search_column_type',
  c: {
    field: {
      l: {
        ja: '通常フィールド',
        en: 'Field'
      },
      d: {}
    },
    code: {
      l: {
        ja: 'コード値',
        en: 'Code'
      },
      d: {}
    },
    title: {
      l: {
        ja: 'タイトル',
        en: 'Title'
      },
      d: {}
    },
    database: {
      l: {
        ja: 'データベース',
        en: 'Database'
      },
      d: {}
    },
    database_site: {
      l: {
        ja: '提供元サイト',
        en: 'Provider Site'
      },
      d: {}
    },
    provider: {
      l: {
        ja: '提供者',
        en: 'Provider'
      },
      d: {}
    },
    organization: {
      l: {
        ja: '連携機関',
        en: 'Organization'
      },
      d: {}
    }
  }
})
export const JPS_CROSS: CustomSearchDefinition = Object.freeze({
  id: 'jps-cross',
  name: {
    ja: '横断検索',
    en: 'Cross Search',
    yomi: 'おうだんけんさく'
  },
  description: {
    ja: '全てのデータベースを横断してキーワード検索します。',
    en: 'Search all databases with keywords.'
  },
  help: {
    ja: {
      ops: [
        {
          insert: 'スペース区切りで複数のキーワードのAND検索ができます。'
        },
        {
          insert: '\n',
          attributes: {
            list: 'bullet'
          }
        },
        {
          insert: '複数のキーワードの前に ',
          attributes: {}
        },
        {
          insert: '+ ',
          attributes: {
            bold: true
          }
        },
        {
          insert: 'を付けると、OR検索（どれか一つでも一致）となります（例：+A +B⇒A or B）。',
          attributes: {}
        },
        {
          insert: '1文字でのAND/OR検索は、2個まで可能です。3個以上は検索に失敗します。'
        },
        {
          insert: '\n',
          attributes: {
            list: 'bullet'
          }
        },
        {
          insert: 'キーワードの前に '
        },
        {
          insert: '- ',
          attributes: {
            bold: true
          }
        },
        {
          insert: 'をつけるとそのキーワードを含むデータは除外されます（NOT検索）。'
        },
        {
          insert: '\n',
          attributes: {
            list: 'bullet'
          }
        },
        {
          insert: ' " " ',
          attributes: {
            bold: true
          }
        },
        {
          insert: 'でキーワードを囲むと厳密な一致のみが検索されます。AND/OR/NOTと組み合わせることが出来ます。'
        },
        {
          insert: '\n',
          attributes: {
            list: 'bullet'
          }
        },
        {
          insert: 'さらに複雑な論理条件での検索は、＋ボタンからサブ検索を追加して下さい。'
        },
        {
          insert: '\n',
          attributes: {
            list: 'bullet'
          }
        }
      ]
    },
    en: {
      ops: [
        {
          insert: 'Separate multiple keywords by spaces (AND search) '
        },
        {
          insert: '\n',
          attributes: {
            list: 'bullet'
          }
        },
        {
          insert: 'Using plus signs (+) on multiple keywords results in OR search (ex. +A +B means A or B)'
        },
        {
          insert: '\n',
          attributes: {
            list: 'bullet'
          }
        },
        {
          insert: 'Use a minus sign (-) to exclude words from your search results.'
        },
        {
          insert: '\n',
          attributes: {
            list: 'bullet'
          }
        },
        {
          insert: ' ',
          attributes: {
            bold: true
          }
        },
        {
          insert: 'Put double quotes ("") around a phrase to search for an exact match'
        },
        {
          insert: '\n',
          attributes: {
            list: 'bullet'
          }
        }
      ]
    }
  },
  searchFields: [
    {
      key: 'rights',
      name: {
        ja: '利用条件',
        en: 'Use Condition'
      },
      type: 'code',
      fields: [
        'common.contentsRightsType'
      ],
      codeKey: 'jps-facet_rights_type',
      hasFacet: true,
      hasSideBarFacet: true,
      sideBarFacetShowCount: -1,
      facetSize: 100
    },
    {
      key: 'contents',
      name: {
        ja: 'コンテンツ',
        en: 'Contents'
      },
      type: 'contents',
      hasFacet: true,
      hasSideBarFacet: true,
      sideBarFacetShowCount: -1,
      facetSize: 100
    },
    {
      key: 'caccess',
      name: {
        ja: 'コンテンツ公開（ファセット互換）'
      },
      type: 'code',
      fields: [
        'common.contentsAccess'
      ],
      codeKey: 'jps-contents_access',
      hidden: true,
      hasSideBarFacet: true,
      sideBarFacetShowCount: -1
    },
    {
      key: 'type',
      name: {
        ja: '種類',
        en: 'Type'
      },
      type: 'rdf_type',
      hasFacet: true,
      hasSideBarFacet: true,
      sideBarFacetShowCount: -1,
      facetSize: 100
    },
    {
      key: 'db',
      name: {
        ja: 'データベース',
        en: 'Database'
      },
      type: 'database',
      hasFacet: true,
      hasSideBarFacet: true,
      sideBarFacetShowCount: -1
    },
    {
      key: 'cm',
      name: {
        ja: '分野',
        en: 'Field'
      },
      type: 'code',
      fields: [
        'common.category'
      ],
      codeKey: 'jps-db_category',
      hasFacet: true,
      hasSideBarFacet: true,
      sideBarFacetShowCount: -1,
      facetSize: 100
    },
    {
      key: 'category',
      name: {
        ja: 'カテゴリー（ファセット互換）'
      },
      type: 'code',
      fields: [
        'common.category'
      ],
      hidden: true,
      hasSideBarFacet: true,
      sideBarFacetShowCount: -1
    },
    {
      key: 'tempo',
      name: {
        ja: '時間/時代',
        en: 'Time'
      },
      type: 'temporal',
      hasFacet: true,
      hasSideBarFacet: true,
      sideBarFacetShowCount: -1
    },
    {
      key: 'loc',
      name: {
        ja: '場所',
        en: 'Location'
      },
      type: 'location',
      hasSideBarFacet: true,
      sideBarFacetShowCount: -1
    },
    {
      key: 'contributor',
      name: {
        ja: '人物/団体',
        en: 'Contributor'
      },
      type: 'keyword',
      fields: [
        'common.contributor'
      ],
      hasSideBarFacet: true,
      sideBarFacetShowCount: -1
    },
    {
      key: 'image',
      name: {
        ja: '画像AI検索',
        en: 'Image AI Search'
      },
      type: 'image',
      hasSideBarFacet: true,
      sideBarFacetShowCount: -1
    },
    {
      key: 'upd',
      name: {
        ja: '最終更新日',
        en: 'Last Updated'
      },
      type: 'last_update',
      fields: [
        'common.lastUpdatedDate'
      ],
      hidden: true,
      hasSideBarFacet: true,
      sideBarFacetShowCount: -1
    },
    {
      key: 'timespan',
      name: {
        ja: '時間/時代',
        en: 'Time'
      },
      type: 'time_range',
      fields: [
        'sindex.times'
      ],
      hidden: true,
      hasSideBarFacet: true,
      sideBarFacetShowCount: -1
    },
    {
      key: 'coordinates',
      name: {
        ja: '場所',
        en: 'Location'
      },
      type: 'coordinates',
      fields: [
        'common.coordinates'
      ],
      hidden: true,
      hasSideBarFacet: true,
      sideBarFacetShowCount: -1
    },
    {
      key: 'description',
      name: {
        ja: '解説有',
        en: 'Description'
      },
      type: 'exist',
      fields: [
        'common.description'
      ],
      hidden: true,
      hasSideBarFacet: true,
      sideBarFacetShowCount: -1
    }
  ],
  columns: [
    {
      header: {
        ja: '人物/団体',
        en: 'Contributor'
      },
      fields: [
        'common.contributor'
      ],
      type: 'field',
      codeKey: null
    },
    {
      header: {
        ja: '時間/時代',
        en: 'Time'
      },
      fields: [
        'common.temporal'
      ],
      type: 'field',
      codeKey: null
    },
    {
      header: {
        ja: '場所',
        en: 'Location'
      },
      fields: [
        'common.location'
      ],
      type: 'field',
      codeKey: null
    },
    {
      header: {
        ja: '所蔵機関',
        en: 'Provider'
      },
      fields: null,
      type: 'provider',
      codeKey: null
    },
    {
      header: {
        ja: 'データベース',
        en: 'Database'
      },
      fields: null,
      type: 'database',
      codeKey: null
    }
  ],
  keywordFields: [
    'common.title',
    'keywords',
    'sindex.english'
  ],
  keywordPlaceholder: {
    ja: '検索キーワードを入力',
    en: 'Input search keyword'
  },
  sampleQuery: [
    {
      name: {
        ja: '富士山',
        en: 'Fuji San(Mt.Fuji)'
      },
      csid: 'jps-cross',
      keyword: [
        '富士山'
      ]
    },
    {
      name: {
        ja: '獅子',
        en: 'Shishi（lion）'
      },
      csid: 'jps-cross',
      keyword: [
        '獅子'
      ]
    },
    {
      name: {
        ja: 'うどん',
        en: 'Udon(noodle)'
      },
      csid: 'jps-cross',
      keyword: [
        'うどん'
      ]
    },
    {
      name: {
        ja: 'カラマツ',
        en: 'Karamatsu(larch)'
      },
      csid: 'jps-cross',
      keyword: [
        'カラマツ'
      ]
    },
    {
      name: {
        ja: '五重塔',
        en: 'Five-storied pagoda'
      },
      csid: 'jps-cross',
      image: [
        'cobas-165288'
      ]
    },
    {
      name: {
        ja: '釣り',
        en: 'Fishing'
      },
      csid: 'jps-cross',
      text2image: '釣り'
    }
  ],
  image: {
    url: '',
    imgType: 'URL'
  },
  permission: {
    level: 'PUBLIC'
  }
})
export const JPS_GALLERYCS: CustomSearchDefinition = Object.freeze({
  id: 'jps-gallerycs',
  name: {
    ja: 'ギャラリー検索',
    en: 'Gallery Search',
    yomi: 'ぎゃらりーけんさく'
  },
  description: {
    ja: 'ギャラリーを検索します。',
    en: 'Search galleries.'
  },
  searchFields: [
    {
      key: 'topic',
      name: {
        ja: 'トピック',
        en: 'Topic'
      },
      type: 'tag',
      fields: [
        'tag.id'
      ],
      hasFacet: true,
      hasSideBarFacet: true,
      sideBarFacetShowCount: -1,
      facetIncludePattern: 'o-.*',
      facetSize: 1000
    },
    {
      key: 'keyword',
      name: {
        ja: 'キーワード',
        en: 'Keyword'
      },
      type: 'tag',
      fields: [
        'tag.id'
      ],
      hasFacet: true,
      hasSideBarFacet: true,
      sideBarFacetShowCount: -1,
      facetIncludePattern: 'w-.*',
      facetSize: 1000
    },
    {
      key: 'ownerOrg',
      name: {
        ja: '作成機関',
        en: 'Created by'
      },
      type: 'owner_org',
      fields: [
        'permission.ownerOrg'
      ],
      hasFacet: true,
      hasSideBarFacet: true,
      sideBarFacetShowCount: -1,
      facetSize: 1000
    },
    {
      key: 'publicationLevel',
      name: {
        ja: '公開状態',
        en: 'Publication level'
      },
      type: 'permission',
      fields: [
        'permission.publicationLevel'
      ],
      hasFacet: true,
      hasSideBarFacet: true,
      sideBarFacetShowCount: -1,
      facetSize: 10
    }
  ],
  keywordFields: [
    'title.ja',
    'title.en',
    'title.yomi',
    'summary.ja',
    'summary.en',
    'keywords'
  ],
  keywordPlaceholder: {
    ja: '検索キーワードを入力',
    en: 'Input search keyword'
  },
  permission: {
    level: 'PUBLIC'
  }
})
export const HINA_CROSS: CustomSearchDefinition = Object.freeze({
  id: 'hina-cross',
  name: {
    ja: '横断検索',
    en: 'Cross Search',
    yomi: 'おうだんけんさく'
  },
  description: {
    ja: '全てのデータベースを横断してキーワード検索します。',
    en: 'Search all databases with keywords.'
  },
  help: {
    ja: {
      ops: [
        {
          insert: 'スペース区切りで複数のキーワードのAND検索ができます。'
        },
        {
          insert: '\n',
          attributes: {
            list: 'bullet'
          }
        },
        {
          insert: '複数のキーワードの前に ',
          attributes: {}
        },
        {
          insert: '+ ',
          attributes: {
            bold: true
          }
        },
        {
          insert: 'を付けると、OR検索（どれか一つでも一致）となります（例：+A +B⇒A or B）。',
          attributes: {}
        },
        {
          insert: '1文字でのAND/OR検索は、2個まで可能です。3個以上は検索に失敗します。'
        },
        {
          insert: '\n',
          attributes: {
            list: 'bullet'
          }
        },
        {
          insert: 'キーワードの前に '
        },
        {
          insert: '- ',
          attributes: {
            bold: true
          }
        },
        {
          insert: 'をつけるとそのキーワードを含むデータは除外されます（NOT検索）。'
        },
        {
          insert: '\n',
          attributes: {
            list: 'bullet'
          }
        },
        {
          insert: ' " " ',
          attributes: {
            bold: true
          }
        },
        {
          insert: 'でキーワードを囲むと厳密な一致のみが検索されます。AND/OR/NOTと組み合わせることが出来ます。'
        },
        {
          insert: '\n',
          attributes: {
            list: 'bullet'
          }
        },
        {
          insert: 'さらに複雑な論理条件での検索は、＋ボタンからサブ検索を追加して下さい。'
        },
        {
          insert: '\n',
          attributes: {
            list: 'bullet'
          }
        }
      ]
    },
    en: {
      ops: [
        {
          insert: 'Separate multiple keywords by spaces (AND search) '
        },
        {
          insert: '\n',
          attributes: {
            list: 'bullet'
          }
        },
        {
          insert: 'Using plus signs (+) on multiple keywords results in OR search (ex. +A +B means A or B)'
        },
        {
          insert: '\n',
          attributes: {
            list: 'bullet'
          }
        },
        {
          insert: 'Use a minus sign (-) to exclude words from your search results.'
        },
        {
          insert: '\n',
          attributes: {
            list: 'bullet'
          }
        },
        {
          insert: ' ',
          attributes: {
            bold: true
          }
        },
        {
          insert: 'Put double quotes ("") around a phrase to search for an exact match'
        },
        {
          insert: '\n',
          attributes: {
            list: 'bullet'
          }
        }
      ]
    }
  },
  searchFields: [
    {
      key: 'contents',
      name: {
        ja: 'コンテンツ',
        en: 'Contents'
      },
      type: 'contents',
      hasFacet: true,
      hasSideBarFacet: true,
      sideBarFacetShowCount: 99,
      facetSize: 100
    },
    {
      key: 'cm',
      name: {
        ja: 'カテゴリー',
        en: 'Category'
      },
      type: 'code',
      fields: [
        'common.category'
      ],
      codeKey: 'jps-db_category',
      hasFacet: true,
      hasSideBarFacet: true,
      sideBarFacetShowCount: -1,
      facetSize: 100
    },
    {
      key: 'prefectures',
      name: {
        ja: '場所',
        en: 'Location'
      },
      type: 'prefectures',
      hasFacet: true,
      hasSideBarFacet: true,
      sideBarFacetShowCount: -1
    },
    {
      key: 'coordinates',
      name: {
        ja: '場所',
        en: 'Location'
      },
      type: 'coordinates',
      fields: [
        'common.coordinates'
      ],
      hidden: true,
      hasSideBarFacet: true,
      sideBarFacetShowCount: -1
    },
    {
      key: 'tempo_group',
      name: {
        ja: '時間',
        en: 'Time'
      },
      type: 'temporal_group',
      hasFacet: true,
      hasSideBarFacet: true,
      sideBarFacetShowCount: -1
    },
    {
      key: 'caccess',
      name: {
        ja: '公開状況',
        en: 'Publication status'
      },
      type: 'code',
      fields: [
        'common.contentsAccess'
      ],
      codeKey: 'jps-contents_access',
      hasFacet: true,
      hasSideBarFacet: true,
      sideBarFacetShowCount: -1
    },
    {
      key: 'db',
      name: {
        ja: '提供元',
        en: 'Provided by'
      },
      type: 'database',
      hasFacet: true,
      hasSideBarFacet: true,
      sideBarFacetShowCount: -1
    },
    {
      key: 'language',
      name: {
        ja: '言語',
        en: 'Language'
      },
      type: 'code',
      fields: [
        'common.language'
      ],
      codeKey: 'jps-language',
      hasFacet: true,
      hasSideBarFacet: true,
      sideBarFacetShowCount: -1,
      facetSize: 100
    },
    {
      key: 'contributor',
      name: {
        ja: '人物/団体',
        en: 'Contributor'
      },
      type: 'keyword',
      fields: [
        'common.contributor'
      ],
      hasSideBarFacet: true,
      sideBarFacetShowCount: -1
    },
    {
      key: 'rights',
      name: {
        ja: '利用条件',
        en: 'Use Condition'
      },
      type: 'code',
      fields: [
        'common.contentsRightsType'
      ],
      codeKey: 'jps-facet_rights_type',
      hasFacet: true,
      hasSideBarFacet: false,
      sideBarFacetShowCount: -1,
      facetSize: 100
    },
    {
      key: 'image',
      name: {
        ja: '画像AI検索',
        en: 'Image AI Search'
      },
      type: 'image',
      hidden: true,
      hasSideBarFacet: true,
      sideBarFacetShowCount: -1
    }
  ],
  columns: [
    {
      header: {
        ja: '人物/団体',
        en: 'Contributor'
      },
      fields: [
        'common.contributor'
      ],
      type: 'field',
      codeKey: null
    },
    {
      header: {
        ja: '時間',
        en: 'Time'
      },
      fields: [
        'common.temporal'
      ],
      type: 'field',
      codeKey: null
    },
    {
      header: {
        ja: '場所',
        en: 'Location'
      },
      fields: [
        'common.location'
      ],
      type: 'field',
      codeKey: null
    },
    {
      header: {
        ja: '提供元',
        en: 'Provided by'
      },
      fields: null,
      type: 'database_site',
      codeKey: null
    }
  ],
  keywordFields: [
    'common.title',
    'keywords',
    'sindex.english'
  ],
  keywordPlaceholder: {
    ja: '検索キーワードを入力',
    en: 'Input search keyword'
  },
  sampleQuery: [],
  image: {
    url: '',
    imgType: 'URL'
  },
  permission: {
    level: 'PUBLIC'
  }
})
export const HINA_GALLERYCS: CustomSearchDefinition = Object.freeze({
  id: 'hina-gallerycs',
  name: {
    ja: 'ギャラリー検索',
    en: 'Gallery Search',
    yomi: 'ぎゃらりーけんさく'
  },
  description: {
    ja: 'ギャラリーを検索します。',
    en: 'Search galleries.'
  },
  searchFields: [
    {
      key: 'keyword',
      name: {
        ja: 'キーワード',
        en: 'Keyword'
      },
      type: 'tag',
      fields: [
        'tag.id'
      ],
      hasFacet: true,
      hasSideBarFacet: true,
      sideBarFacetShowCount: -1,
      facetIncludePattern: 'w-.*',
      facetSize: 1000
    },
    {
      key: 'ownerOrg',
      name: {
        ja: '作成機関',
        en: 'Created by'
      },
      type: 'owner_org',
      fields: [
        'permission.ownerOrg'
      ],
      hasFacet: true,
      hasSideBarFacet: true,
      sideBarFacetShowCount: -1,
      facetSize: 1000
    },
    {
      key: 'publicationLevel',
      name: {
        ja: '公開状態',
        en: 'Publication level'
      },
      type: 'permission',
      fields: [
        'permission.publicationLevel'
      ],
      hasFacet: true,
      hasSideBarFacet: true,
      sideBarFacetShowCount: -1,
      facetSize: 10
    }
  ],
  keywordFields: [
    'title.ja',
    'title.en',
    'title.yomi',
    'summary.ja',
    'summary.en',
    'keywords'
  ],
  keywordPlaceholder: {
    ja: '検索キーワードを入力',
    en: 'Input search keyword'
  },
  permission: {
    level: 'PUBLIC'
  }
})
